import { Cart } from "../cart/CartTypes";
import { DiscountResponseItem } from "../common/DiscountList";

export namespace ReserveState {
  export type PageData = {
    order_data: OrderData;
    state_data: StateData;
    cancel_questionnaire_options?: CancelQuestionnaireOption[];
  }

  // subtotal: 商品小計
  // tax_and_service: 平臺費
  // after_tax_price: 平臺費 + 商品小計
  // sportz_voucher: 動滋券
  // total_price: 最總價格
  // points_reward： 點數回饋
  // OrderData被應用很多地方，subtotal暫時處理非必填
  export type OrderData = {
    state?: OrderState;
    order_sn: string;
    discounts: DiscountResponseItem[];
    ep_reduce: number;
    subtotal?: number;
    after_tax_price?: number;
    sportz_voucher?: number;
    tax_and_service?: number;
    total_price: number;
    cart_record: CartRecord;
    tax_rate: number;
    service_rate: number;
    reserve_record?: ReserveRecord;
    points_reward?: number;
  }

  export type CartRecord = {
    name: string;
    plan_data: Cart.PlanData;
  }

  export type ReserveRecord = {
    first_name: string;
    surname: string;
    country: string;
    phone: string;
    email: string;
    birth_date: string;
    gender: string;
    id_number: string;
    id_number_is_passport: boolean;
    height: string;
    weight: string;
  }

  export type StateData = {
    state: OrderState;
    atm_data?: ATMData;
    fail_reaspons?: string[];
    cancel_detail?: CancelDetail;
  }

  export type CancelDetail = {
    is_cancel_by_system: boolean;
    refund_raw: number;
    refund_handling_fee: number;
    refund_amount: number;
    refund_sports_voucher_point?: number;
    system_cancel_reason?: string;
  }

  export type CancelQuestionnaireOption = {
    id: string;
    text: string;
  }

  export type ReserveStateSetting = {
    title?: string
    detail?: string
    mainState: "pay" | "cancel" | "normal" | "started"
    cancelLabel?: string
    checkIcon?: string
    collapseContent?: boolean
  }

  export type ATMData = {
    code: string;
    name: string;
    account: string;
    amount: string;
    due_date: string;
  }

  export enum OrderState {
    pay_pending = "pay_pending",
    pay_fail = "pay_fail",
    confirm_pending = "confirm_pending",
    passenger_filling = "passenger_filling",
    all_ready = "all_ready",
    started = "started",
    cancel_pending = "cancel_pending",
    cancel_fail = "cancel_fail",
    cancel_success = "cancel_success",
    refund_success = "refund_success",
    cancel_and_no_refund = "cancel_and_no_refund"
  }

  export const Setting: { [key: string]: ReserveStateSetting } = {
    "pay_pending": {
      title: "繳費進行中",
      detail: "感謝您從 EZOUTDOOR 報名下列活動，\n請在繳費期限前完成付款，逾期訂單將自動釋出，謝謝。",
      mainState: "normal",
    },
    "pay_fail": {
      title: "繳費失敗",
      detail: "繳款失敗原因如下：",
      mainState: "normal",
      checkIcon: "fail",
      collapseContent: true,
    },
    "confirm_pending": {
      title: "等待訂單確認",
      detail: "將於2個工作日內回覆訂購結果，成功報名將寄「活動報名確認信 」到您的註冊信箱；\n收到確認信還須填寫同行旅客資料才算完成報名流程喔!\n請務必於指定時間內完成資料填寫，感謝配合！",
      mainState: "pay",
    },
    "all_ready": {
      title: "報名完成",
      detail: "為了讓你更盡興地享受行程，將於活動前三天提供行前通知，再請注意 E-mail 訊息通知。",
      mainState: "normal",
    },
    "started": {
      mainState: "started"
    },
    "cancel_pending": {
      title: "已收到取消申請，訂單審核中",
      detail: "將於2個工作日內回覆申請結果，您可以透過網站上方會員專區的「訂單管理」查看自己的退款申請狀態。",
      mainState: "cancel",
      cancelLabel: "已申請取消訂單",
    },
    "cancel_fail": {
      title: "訂單取消失敗",
      detail: "您的訂單取消申請未能通過核准，請參閱各行程之「取消辦法」。",
      mainState: "cancel",
      cancelLabel: "訂單取消失敗",
      checkIcon: "fail",
    },
    "cancel_success": {
      title: "訂單取消成功",
      detail: "已向原付款銀行提出退款請求，您可以透過網站上方會員專區的\n「訂單管理」查看自己的退款處理狀態。",
      mainState: "cancel",
      cancelLabel: "訂單已取消",
    },
    "refund_success": {
      title: "退款成功",
      detail: "您將在10 - 21個工作日內收到退款，實際時間視發卡銀行而定。",
      mainState: "cancel",
      cancelLabel: "訂單已取消",
    },
    "cancel_and_no_refund": {
      title: "無法前往體驗",
      detail: "由於您未提供完整旅客資料，我們將無法進行保險相關事宜，\n未保險之旅客將不得前往參加活動體驗。",
      mainState: "cancel",
      cancelLabel: "訂單已取消",
      checkIcon: "alert",
    }
  };
}